import { useEffect, useState } from 'react'
import './BotAnimation.css'

interface BotAnimationProps {
  mode?: 'happy' | 'sad' | 'surprised'
}

export default function BotAnimation({ mode: externalMode }: BotAnimationProps) {
  // Use external mode directly if provided, otherwise cycle through modes
  const [internalMode, setInternalMode] = useState<'happy' | 'sad' | 'surprised'>('happy')
  const mode = externalMode || internalMode

  // Auto-cycle animation when no external mode
  useEffect(() => {
    if (externalMode) {
      return
    }

    const interval = setInterval(() => {
      setInternalMode(prev => {
        if (prev === 'happy') {
          return 'sad'
        }
        if (prev === 'sad') {
          return 'surprised'
        }
        return 'happy'
      })
    }, 4000)

    return () => clearInterval(interval)
  }, [externalMode])

  return (
    <div className={`bot-page bot-${mode}`}>
      <div className="bot-container">
        <div className="bot-bg">
          <i className="bg" />
          <i className="bg2" />
          <i className="bg3" />
        </div>
        <div className="bot">
          <div className="bot-head">
            <div className="bot-face">
              <i className="eye eye-left" />
              <i className="eye eye-right" />
              <div className="mouth" />
            </div>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 219 157">
              <g>
                <path className="st0" d="M212.1,60.2l-7.4-1c0.7-14.5-0.1-26.4-3.7-30.4C172.4-2.8,44.2,0.2,17,28.8c-4.1,4.4-5.1,16.3-4.3,30.6
                  l-5.8,0.8c0,0-2,14.7,0.1,29.2c2.1,15.2,8.3,30.2,8.3,30.2l6.6-0.9c2.1,8.5,4,14.6,5.1,16.1c4.9,6.5,35.7,15,82,15
                  c46.3,0,76.3-8.3,82-15c1.4-1.6,3.2-7.7,5.2-16.2l7.5,1.1c0,0,6.1-15,8.3-30.2C214,74.9,212.1,60.2,212.1,60.2z"/>
              </g>
              <path className="st1" d="M204,27.8C175.4-3.8,43.2-0.8,16,27.8c-4,4.2-5,15.3-4.4,28.9c13.4,33.9,32.6,70,45.2,70c23.8,0,19.6-7,52-7
                c26.1,0,20.2,7,52,7c13.3,0,33.5-39.4,47.1-74.5C208.1,40.5,207.1,31.2,204,27.8z"/>
            </svg>
          </div>
          <div className="bot-body">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 226 175">
              <path className="st0" d="M213.7,47.8c-8-13.9-18.9-23.8-28.2-26.9c-0.3-0.6-0.6-1.1-1-1.4c-11.3-12.2-133-15-144,0
                c-0.4,0.6-0.8,1.4-1.1,2.3c-8.8,3.8-18.6,13.2-26,26.1c-11.8,20.5-2.9,47.8-2.9,47.8s18.7-3.9,32-16.5c5.8,35,15.2,72.8,18,76.4
                c4.9,6.5,5.7,15,52,15c46.3,0,46.3-8.3,52-15c3.2-3.8,12.7-42.6,18.4-78c13.4,13.8,33.6,18.1,33.6,18.1S225.5,68.3,213.7,47.8z"/>
            </svg>
          </div>
          <div className="levitas">
            <i className="levitas-first" />
            <i className="levitas-second" />
            <i className="levitas-third" />
            <i className="levitas-four" />
          </div>
          <i className="bot-shadow" />
        </div>
      </div>
    </div>
  )
}
